import type { IconProps } from './types';

export const GearIcon = (props: IconProps) => {
  const {
    width = 18,
    height = 20,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      className={className}
    >
      <path
        d="M7.27717 2.46571L6.72431 3.89286L4.82145 4.97286L3.30431 4.74143C3.05168 4.70714 2.79457 4.74872 2.56564 4.8609C2.33671 4.97308 2.14629 5.15077 2.01859 5.37143L1.50431 6.27143C1.37252 6.49559 1.3118 6.75445 1.33017 7.01383C1.34853 7.27321 1.44511 7.52092 1.60717 7.72429L2.57145 8.92V11.08L1.63288 12.2757C1.47083 12.4791 1.37425 12.7268 1.35589 12.9862C1.33751 13.2456 1.39824 13.5044 1.53002 13.7286L2.04431 14.6286C2.17201 14.8492 2.36242 15.0269 2.59135 15.1391C2.82029 15.2512 3.07739 15.2929 3.33002 15.2586L4.84717 15.0271L6.72431 16.1071L7.27717 17.5343C7.37039 17.7759 7.53444 17.9838 7.7478 18.1306C7.96115 18.2774 8.21389 18.3564 8.47288 18.3571H9.55288C9.81187 18.3564 10.0646 18.2774 10.278 18.1306C10.4913 17.9838 10.6554 17.7759 10.7486 17.5343L11.3015 16.1071L13.1786 15.0271L14.6957 15.2586C14.9484 15.2929 15.2055 15.2512 15.4344 15.1391C15.6634 15.0269 15.8538 14.8492 15.9815 14.6286L16.4957 13.7286C16.6275 13.5044 16.6882 13.2456 16.6698 12.9862C16.6516 12.7268 16.5549 12.4791 16.3929 12.2757L15.4286 11.08V8.92L16.3672 7.72429C16.5292 7.52092 16.6259 7.27321 16.6441 7.01383C16.6625 6.75445 16.6018 6.49559 16.47 6.27143L15.9557 5.37143C15.8281 5.15077 15.6377 4.97308 15.4087 4.8609C15.1798 4.74872 14.9227 4.70714 14.67 4.74143L13.1529 4.97286L11.2757 3.89286L10.7229 2.46571C10.6296 2.22408 10.4656 2.01624 10.2522 1.86941C10.0389 1.72259 9.78616 1.64362 9.52717 1.64286H8.47288C8.21389 1.64362 7.96115 1.72259 7.7478 1.86941C7.53444 2.01624 7.37039 2.22408 7.27717 2.46571Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.86196 11.4286C6.57941 11.0057 6.4286 10.5086 6.4286 10C6.4286 9.31802 6.69951 8.66396 7.18176 8.18173C7.66399 7.69948 8.31804 7.42857 9.00003 7.42857C9.5086 7.42857 10.0058 7.57939 10.4286 7.86193C10.8515 8.14448 11.1811 8.54609 11.3757 9.01595C11.5703 9.48583 11.6213 10.0029 11.522 10.5017C11.4228 11.0005 11.1779 11.4587 10.8183 11.8183C10.4587 12.1779 10.0005 12.4228 9.50169 12.522C9.00288 12.6212 8.48586 12.5703 8.01598 12.3757C7.54611 12.1811 7.14451 11.8515 6.86196 11.4286Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
